// extracted by mini-css-extract-plugin
export var cardIcon = "_5c-4";
export var checkboxCard = "_5c-0";
export var checkboxCardSelected = "_5c-3";
export var disabled = "_5c-1";
export var outerBorder = "_5c-2";
export var spacerMedium = "_5c-7";
export var spacerSmall = "_5c-6";
export var spacerXsmall = "_5c-5";